<template>
    <div id="delete-all-media-modal" class="modal-new hidden">
        <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <span class="title">Remove all assets</span>
        <p class="description">Are you sure you want to remove all assets from fylm.ai?</p>
        <div class="buttons-continer">
            <v-btn @click="confirm" :disabled="processing" dark class="modal-btn --primary --delete">
                <v-progress-circular v-if="processing" color="#fff" indeterminate size="18" width="3" />
                <template v-else>Confirm</template>
            </v-btn>
            <button @click="close" type="button" class="modal-btn --cancel">Cancel</button>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            processing: false
        }
    },

    methods: {
        async confirm() {
            this.processing = true;
            await this.$store.dispatch('File/Media/deleteAll');
            this.processing = false;

            this.close();
        },
        close() {
            window.UI.hideModal();
        }
    }
};
</script>

<style></style>
